import { Button } from '@good/ui/core';
import { useDisclosure } from '@good/ui/hooks';
import { notifications } from '@good/ui/notifications';
import React from 'react';
import { useCustomer } from 'stores/hooks/query-hooks/use-query-fetch-customer';
import { CreateAgreementLinkModal } from './create-agreement-link-modal';
import { useNewRelicBrowser } from 'integrations/new-relic-browser';
import { reactTrpc } from 'utilities/react-trpc';
import { useFlags } from 'launchdarkly-react-client-sdk';

interface CreateAgreementLinkButtonProps {
  userServiceAgreementId: string;
  customerUserId: string;
}

export const CreateAgreementLinkButton = ({
  userServiceAgreementId,
  customerUserId,
}: CreateAgreementLinkButtonProps) => {
  const { serviceAgreementSignatures } = useFlags<{ serviceAgreementSignatures: boolean }>();
  const logger = useNewRelicBrowser();
  const { data: customer } = useCustomer({ customerUserId });
  const [modalOpened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const {
    data: latestHistoryId,
    isLoading,
    isError,
  } = reactTrpc.customers.userServiceAgreementHistories.fetchLatestHistoryId.useQuery({
    userServiceAgreementId,
  });

  const onOpenModal = () => {
    if (!latestHistoryId) {
      notifications.show({
        title: 'Service agreement version not found',
        message: 'Cannot create agreement link because the service agreement version is missing.',
        color: 'red',
      });
      logger?.noticeError('CreateAgreementLinkButton: Missing historyId when trying to open modal');
      return;
    }

    if (!customer?.dateOfBirth) {
      notifications.show({
        title: 'Date of birth must be set',
        message: 'To help keep the link secure, a date of birth must be set on the customer before sending.',
        color: 'red',
      });
      return;
    }

    openModal();
  };

  if (!serviceAgreementSignatures) {
    return null;
  }

  return (
    <>
      <Button onClick={onOpenModal} loading={isLoading} disabled={isError}>
        Send to customer
      </Button>
      <CreateAgreementLinkModal opened={modalOpened} onClose={closeModal} historyId={latestHistoryId} />
    </>
  );
};
